import urlBuilder from "./urlBuilder";
import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

interface DictionaryResponse {
    [key: string]: string;
}

export default async (route: string): Promise<DictionaryResponse> => {
    const url = urlBuilder("/api/translations", { route: route });

    const response = await fetch(url.toString(),
        {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Origin": getUmbracoEndPoint(),
                "X-Request-Domain": getUmbracoEndPoint()
            },
            body: undefined
        });

    return await response.json();
};